import { render, staticRenderFns } from "./ValidateDocuments.vue?vue&type=template&id=20b6fde7&"
import script from "./ValidateDocuments.vue?vue&type=script&lang=js&"
export * from "./ValidateDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports